export default "__VITE_PUBLIC_ASSET__db3508e6__"